var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {


















pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};






































pug_html = pug_html + "\u003Ch2\u003ECreate loan request\u003C\u002Fh2\u003E\u003Cform layout=\"column\" layout-padding flex name=\"vm.createForm\" api-form=\"vm.confirmAction()\"\u003E\u003Cabn-lookup label=\"ABN\" abn-model=\"vm.abn\" name-model=\"vm.businessName\" trading-since-model=\"vm.tradingSince\" required=\"true\"\u003E\u003C\u002Fabn-lookup\u003E\u003Cinput-container label=\"Name\"\u003E\u003Cinput required name=\"businessName\" ng-model=\"vm.businessName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Trading since\"\u003E\u003Cinput required name=\"tradingSince\" ng-model=\"vm.tradingSince\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Funding source\"\u003E\u003Cmd-select class=\"required-select big-list funding-source\" required name=\"fundingSource\" ng-model=\"vm.fundingSource\" aria-label=\"Funding source\"\u003E\u003Cmd-option ng-repeat=\"fundingSource in vm.fundingSources\" value=\"{{fundingSource.value}}\"\u003E{{fundingSource.label}}\u003C\u002Fmd-option\u003E\u003C\u002Fmd-select\u003E\u003Cdiv class=\"md-errors-spacer\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Finput-container\u003E\u003Cinput-container ng-if=\"vm.fundingSource === 'auction'\" label=\"Amount\"\u003E\u003Cinput required type=\"number\" string-to-number name=\"amount\" min=\"50\" step=\"50\" ng-model=\"vm.amount\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least $50\u003C\u002Fng-message\u003E\u003Cng-message when=\"step\"\u003EMust be multiple of $50\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container ng-if=\"vm.fundingSource !== 'auction'\" label=\"Amount\"\u003E\u003Cinput required type=\"number\" string-to-number name=\"amount\" min=\"50\" step=\"0.01\" ng-model=\"vm.amount\" pattern=\"\\d{1,}(\\.\\d{0,2})?\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least $50\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Term\"\u003E\u003Cinput required type=\"number\" name=\"term\" min=\"1\" max=\"84\" step=\"1\" ng-model=\"vm.term\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least 1\u003C\u002Fng-message\u003E\u003Cng-message when=\"max\"\u003EMust be less than 84\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cdiv class=\"actions\" layout=\"row\"\u003E\u003Cmd-button class=\"md-raised md-primary create\" type=\"submit\"\u003ECreate!\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised cancel\" type=\"button\" ng-click=\"vm.cancelAction()\"\u003ECancel\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;